<script>
	import API from '../States/API';
	import Router from '../States/Router';
	import Helper from '../Models/Helper';

	async function signIn(event) {
		const form = Helper.form(event.target);
		const response = await API.signIn(form);
		if(response.success)
			Router.component('dashboard');
	}

</script>

<style>
	#app-title {
		font-family: "Grand Hotel";
		color: white;
		font-size: 3em;
	}
</style>

<div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-xxl-4 col-lg-5">
				<div class="card">
					<div id="app-title" class="card-header pt-2 pb-2 text-center bg-primary">
						Speakly
					</div>
					<div class="card-body p-4">
						<div class="text-center w-75 m-auto">
							<h4 class="text-dark-50 text-center mt-0 fw-bold">Sign In</h4>
						</div>
						<form on:submit|preventDefault={signIn}>
							<div class="mb-3">
								<label for="emailaddress" class="form-label">Email address</label>
								<input class="form-control" type="email" name="mail" required placeholder="Enter your email">
							</div>
							<div class="mb-3">
								<label for="password" class="form-label">Password</label>
								<div class="input-group input-group-merge">
									<input type="password" name="password" class="form-control" placeholder="Enter your password">
								</div>
							</div>
							<div class="mb-3 mb-0 text-center">
								<button class="btn btn-primary" type="submit"> Log In </button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>